module.exports = "/packs/images/pages/venues/library_mobile~c43565dc2408cfe848550721c7761725.jpg";